// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__UH11e","active":"Tab_active__cn0T8","tabText":"Tab_tabText__gsaaM","infoBadge":"Tab_infoBadge__dErs6"};